import { ButtonLooks, FontIcons, StandardButton } from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { emptyPage } from '@constants/page';
import { PagesContext } from '@context/pages';

import { PagesAddEditPage } from './pages-add-edit-page';
import { PagesList } from './pages-list';

interface PagesPopoutProps extends HTMLAttributes<HTMLDivElement> {}

const UnstyledPagesPopout: FunctionComponent<PagesPopoutProps> = (props) => {
  const { editingPage, setEditingPage } = useContext(PagesContext);

  return (
    <div
      {...props}
      className={classNames({
        'page-popout': true,
        [`${props?.className}`]: !!props?.className
      })}
    >
      {editingPage ? (
        <PagesAddEditPage />
      ) : (
        <>
          <StandardButton
            look={ButtonLooks.Default}
            onClick={(): void => {
              setEditingPage(emptyPage);
            }}
            startIcon={FontIcons.Plus}
          >
            Add page
          </StandardButton>
          <PagesList />
        </>
      )}
    </div>
  );
};

const StyledPagesPopout = styled(UnstyledPagesPopout)`
  .bf-button__standard {
    height: 50px;

    .bf-icon__font {
      font-size: 10px;
      margin-inline-end: 8px;
    }
  }
`;

export const PagesPopout: FunctionComponent = () => {
  return <StyledPagesPopout />;
};
